// Which frame a page's content sits in, so the top bar can line itself up
// with it (CustomerHeader). Without this the bar spans the whole content
// column while a centred page stops at 1440px: from ~1750px wide the first
// crumb sat left of the page title and the bell right of the content.
//
//   list    the page is a centred PageContainer "list" frame (max 1440px,
//           32px gutter) with nothing beside it; the bar's row takes the
//           same box, so crumbs start where the title starts and the bell
//           ends where the content ends
//   full    master-detail, rails, canvases (agents, projects, todos, org):
//           full width, as the page is
//
// Keep LIST_PAGES in step with each page's container. A page missing here
// only means its crumbs sit at the gutter on very wide screens. A hub's
// tabs keep one frame for all its pages (hubFrameFor).

import { matchesPath } from "./navModel";

export type PageFrame = "full" | "list";

const LIST_PAGES = [
  "/dashboard",
  "/tasks",
  "/meetings",
  "/record", // RecorderPanel centres its stage inside the list frame
  "/deliverables",
  "/schedules",
  "/skills",
  "/subagents",
  "/workflows",
  "/shared",
  "/code",
  "/settings",
  "/ui-guide",
];

export function pageFrameFor(pathname: string): PageFrame {
  return LIST_PAGES.some((p) => matchesPath(pathname, p)) ? "list" : "full";
}

/** One frame for a hub's pages while the bar shows their tabs: "list" only
 *  when every one is a list page. Projects (full) and Deliverables (list)
 *  would otherwise move the tabs sideways under the pointer on a wide
 *  screen each time you switch between them. */
export function hubFrameFor(pathnames: string[]): PageFrame {
  return pathnames.every((p) => pageFrameFor(p) === "list") ? "list" : "full";
}

/** The header row's box for a frame (PageContainer "list" geometry). */
export const FRAME_ROW: Record<PageFrame, string> = {
  full: "",
  list: "mx-auto max-w-[1440px]",
};
